// Environment configuration
export const config = {
  // Supabase Configuration
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL ,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    serviceRoleKey: import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY,
  },
  
  // App Configuration
  app: {
    name: 'Brutt Admin Console',
    version: '1.0.0',
    description: 'Brutt - Admin Console Dashboard',
    url: import.meta.env.VITE_APP_URL || 'http://localhost:3000',
  },
  
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
    timeout: 10000,
  },
  
  // Feature Flags
  features: {
    enableAuth: false, // Disabled for now
    enableAnalytics: false,
    enableNotifications: true,
  },
  
  // Development Configuration
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

export default config;
